interface CurrentCulture {
  culture: string,
  cultureCode: string,
  cultureImport: any;
}

export class CultureHelper {
  public static async getCurrentCulture(): Promise<CurrentCulture> {
    const currentCulture = {} as CurrentCulture;

    currentCulture.culture = (window as any).currentCultureCode || "nl-NL";
    currentCulture.cultureCode = currentCulture.culture.substr(0, 2);

    if (currentCulture.cultureCode.indexOf("en") === 0) {
      currentCulture.culture = "en-US";
    }

    // Import the locale
    const module = await import("date-fns/locale");

    if (module[currentCulture.cultureCode]) {
      currentCulture.cultureImport = module[currentCulture.cultureCode];
    } else if (module[currentCulture.culture.replace('-', '')]) {
      currentCulture.cultureImport = module[currentCulture.culture.replace('-', '')];
    } else {
      // if all else fails
      currentCulture.cultureImport = module['nl'];
    }

    return currentCulture;
  }
}